const validateAndNormaliseWebContext = (webContextDelegate = {}) => {
  const { browseCountry, browseCurrency, platform } = webContextDelegate;

  if (!browseCountry || !browseCurrency || !platform) {
    throw new Error(
      "WebContext: missing required properties - browseCountry, browseCurrency or platform."
    );
  }

  return {
    browseCountry,
    browseCurrency,
    platform: platform === "mobile" ? platform : "desktop"
  };
};

export default validateAndNormaliseWebContext;
